import styled from "styled-components";

export const MessageContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const UserMessage = styled.div`
  display: flex;
  padding: var(--Spacing-1x, 4px) var(--Spacing-2x, 8px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--Spacing-1x, 4px);
  align-self: stretch;
  max-width: 80%;
  margin-left: auto; /* Align to right */
  background-color: #F6F9FF;
  border-radius: 8px;
  color: ${(props) => props.theme?.colors?.text?.body || "#5C5C5C"};
`;

export const SystemMessage = styled.div`
  color: var(--Text-Body, #5C5C5C);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: var(--Body-Regular-M, 14px);
  font-style: normal;
  font-weight: var(--Body-Regular-Weight, 400);
  line-height: 20px; /* 142.857% */
  max-width: 80%;
  margin-right: auto; /* Align to left */
  padding: var(--Spacing-1x, 4px) var(--Spacing-2x, 8px);
  /* No background-color as specified */
`;

